import { Colors, Metrics } from "../../resources";
import React, { useEffect, useState } from "react";
import { TouchableOpacity, View } from "react-native";

import { SToggleSelect } from "../../types";

interface IProps {
  selected?: SToggleSelect;
  height: number;
  iconLeft: JSX.Element;
  iconRight: JSX.Element;
  onPressLeft: () => void;
  onPressRight: () => void;
}

const SToggle: React.FC<IProps> = ({
  selected: selection = SToggleSelect.LEFT,
  height,
  iconLeft,
  iconRight,
  onPressLeft,
  onPressRight,
}) => {
  const [choice, setChoice] = useState<SToggleSelect>(selection);

  useEffect(() => {
    setChoice(selection);
  }, [selection]);

  const onLeft = () => {
    onPressLeft();
    setChoice(SToggleSelect.LEFT);
  };

  const onRigth = () => {
    onPressRight();
    setChoice(SToggleSelect.RIGHT);
  };

  return (
    <View
      style={{
        height: height,
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <TouchableOpacity
        style={{
          height: height - 12,
          borderWidth: 1,
          borderRightWidth: choice === SToggleSelect.LEFT ? 0 : 1,
          borderColor: Colors.grey200,
          borderBottomLeftRadius: 6,
          borderTopLeftRadius: 6,
          backgroundColor:
            choice === SToggleSelect.LEFT ? Colors.grey100 : Colors.transparent,
        }}
        onPress={onLeft}
      >
        {iconLeft}
      </TouchableOpacity>
      <TouchableOpacity
        style={{
          height: height - 12,
          borderWidth: 1,
          borderLeftWidth: choice === SToggleSelect.RIGHT ? 0 : 1,
          borderColor: Colors.grey200,
          borderBottomRightRadius: 6,
          borderTopRightRadius: 6,
          backgroundColor:
            choice === SToggleSelect.RIGHT
              ? Colors.grey100
              : Colors.transparent,
        }}
        onPress={onRigth}
      >
        {iconRight}
      </TouchableOpacity>
    </View>
  );
};

export default SToggle;
